// extracted by mini-css-extract-plugin
module.exports = {"activityInfo":"activityInfo_activityInfo__3tG_K","activity_title":"activityInfo_activity_title__2nHBZ","desc":"activityInfo_desc__2VP3N","time":"activityInfo_time__iA73K"};